import { useRealtimeServices } from '@/contexts/realTime';
import { firestoreDataProvider } from '@/providers/dataProvider/firestoreDataProvider';
import { supabaseDataProvider } from '@/providers/dataProvider/supabaseDataProvider';
import { useMemo } from 'react';
import { useRealtimeDbProviderName } from './useRealtimeDbProviderName';

export const useRealtimeDbDataProvider = (defaultDataProviderName: string | null = null) => {
  const dataProviderName = useRealtimeDbProviderName(defaultDataProviderName);
  const { realtimeClient: realtimeServices } = useRealtimeServices();

  return useMemo(() => {
    // Explicit provider selection
    if (dataProviderName === 'firestore') {
      return firestoreDataProvider(realtimeServices);
    }

    if (dataProviderName === 'supabase') {
      return supabaseDataProvider(realtimeServices);
    }
  }, [dataProviderName, realtimeServices]);
};
